var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullscreen = function SvgFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.496 20.5v-4.711h1.5V19h3.212v1.5zm12.298 0V19h3.212v-3.211h1.5V20.5zM3.496 8.212V3.5h4.712V5H4.996v3.211zm15.51 0V5h-3.212V3.5h4.712v4.711z"
  })));
};
export default SvgFullscreen;